import { api } from "../../shared/api/client";
import type {
  DuplicateCheckResponse,
  DuplicateDecisionRequest,
  DuplicateDecisionResponse,
  KycSubmitResponse,
  LeadCreateRequest,
  LeadCreateResponse,
  LeadGetResponse,
  LeadPhotoType,
  LeadPhotoUploadResponse,
} from "./types";

/**
 * Field-journey API calls (customer-service, /api/v1 base).
 * Endpoints and shapes per contracts/api/v1/customers.yaml + kyc.yaml.
 */

export function createLead(body: LeadCreateRequest) {
  return api.post<LeadCreateResponse>("/leads", body);
}

export function getLead(id: number) {
  return api.get<LeadGetResponse>(`/leads/${id}`);
}

export function runDuplicateCheck(leadId: number) {
  return api.post<DuplicateCheckResponse>(`/leads/${leadId}/duplicate-check`, {});
}

export function submitDuplicateDecision(leadId: number, body: DuplicateDecisionRequest) {
  return api.post<DuplicateDecisionResponse>(`/leads/${leadId}/duplicate-decision`, body);
}

/** KYC submit is idempotent server-side via the Idempotency-Key header. */
export function submitKyc(leadId: number, idempotencyKey: string) {
  return api.post<KycSubmitResponse>("/kyc/submissions", { lead_id: leadId }, idempotencyKey);
}

/**
 * Upload a field-capture photo (POST /leads/:id/photos, TASK-007a).
 * Multipart form: file + photo_type. 400 invalid type/ext, 413 over 10 MB.
 */
export function uploadLeadPhoto(leadId: number, photoType: LeadPhotoType, file: File) {
  const form = new FormData();
  form.append("file", file, file.name);
  form.append("photo_type", photoType);
  return api.upload<LeadPhotoUploadResponse>(`/leads/${leadId}/photos`, form);
}
